'use client';

import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import queryString from 'query-string';

import { ENV } from '@shared/config';
import { NotesCardQueryData } from '@shared/types';
import { decodeHtmlEntities } from '@shared/utils';
import { getCurrency } from '../../../app/currency';

import { Note } from './keys';

interface QueryParams {
  urlMusician: string | null;
  urlTitle: string | null;
  urlArrangement: string | null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useGetNoteQuery({ 
  urlMusician,
  urlTitle,
  urlArrangement,
}: QueryParams) {
  return useQuery({
    queryKey: [Note, urlMusician, urlTitle, urlArrangement],
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/await-thenable
      const currency = await getCurrency();

      const { data } = await axios.get<NotesCardQueryData>(
        `${ENV.API}/note/${urlMusician}:${urlTitle}:${urlArrangement}/?${queryString.stringify({
            currency,
            lang: ENV.LANG,
          })}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      );
      return decodeHtmlEntities(data.data);
    },
    refetchOnMount: 'always',
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });
}
